<template>
  <div class="search" @touchmove.prevent @mousewheel.prevent>
    <!-- 输入框 -->
    <div class="searchBox">
      <div class="content">
        <div class="input">
          <van-search
            clearable
            @clear="clear()"
            v-model="value"
            placeholder="请输入选手编号或名称"
          />
        </div>
        <div class="btns">
          <div class="searchBtn">
            <van-button
              @click="gotoVote()"
              type="primary"
              :style="{
                background: 'linear-gradient(86deg,#f3746d 0%,#fe3265 100%)',
              }"
              >搜索</van-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close">
      <van-icon @click="close()" name="close" />
    </div>
  </div>
</template>

<script>
import searchMixin from "@/mixins/search.js";
export default {
  mixins: [searchMixin],
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem("info")),
    };
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-icon {
  color: #ccc !important;
}
/deep/ .van-field__control {
  color: #fff;
 ::-ms-input-placeholder {
  color: #ffffff;
  font-weight: 400;
}
}
.search {
  width: 10rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  .searchBox {
    width: 8.75rem;
    height: 5.3099999rem;
    box-sizing: border-box;
    position: relative;
    background: url("@/assets/writer/search-bg.png");
    background-size: 100% 100%;
    .content {
      width: 96%;
      position: absolute;
      bottom: .5666667rem;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 0.08rem;
      .input {
        margin: .8rem 0 .8rem;
        padding: 0 .1rem;
        .van-search {
          background: linear-gradient(
            180deg,
            #aa9fff 0%,
            #7e6dff 100%
          ) !important;
          box-shadow: inset 0 0.02rem 0.02rem #160b91;
          height: 1.067rem;
          padding: 0 .3rem;
          margin: 0 .2666667rem;
          border-radius: .15rem;
          .van-search__content {
            background: linear-gradient(
              180deg,
              #aa9fff 0%,
              #7e6dff 100%
            ) !important;
          }
        }
      }
      .btns {
        display: flex;
        justify-content: center;
        .searchBtn {
          height: .96rem;
          width: 4.96rem;
          box-sizing: border-box;
          .van-button {
            width: 100%;
            height: 100%;
            background: #c7171e;
            border: none;
          }
        }
      }
    }
  }
  div.close {
    margin-top: .5333333rem;
    .van-icon-close {
      font-size: .96rem;
      color: #fff;
    }
  }
}
</style>